/**
 * Language to hand to Keycloak as `ui_locales` (keycloak-js `locale` option).
 *
 * `ui_locales` is stored on the Keycloak auth session, so the login pages stay
 * in the user's language across the UAE PASS round trip (a `kc_locale` only
 * applies to the one request it is on) and, with the identity provider's
 * "Pass current locale" setting, UAE PASS itself opens in that language.
 */
export const currentUiLocale = (): string => {
    if (typeof window === "undefined") return "en";
    let lang: string | null = null;
    try {
        // Set by the language switcher (Topbar); falls back to the server-rendered <html lang>.
        lang = sessionStorage.getItem("lang");
    } catch { }
    lang = lang || document.documentElement.lang || "en";
    return lang.slice(0, 2).toLowerCase();
};
